import React from 'react';
import { Helmet } from 'react-helmet';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';

import RegisteArea from './RegisteArea/RegisteArea';

   const  renderTitle = () =>  {

        return (
            <>
                <div className="title-section">
                    <h4 className="content-title mt-30">
                        Register here for appointment bookings, filling out forms, sick notes, medication refills and more. See our Services tab above for details.
                    </h4>

                </div>
            </>
        )
    }

const Register = () => {
    return (
        <>
            <Helmet>
                <title>Sign up | South Vancouver Medical Clinic | Vancouver doctor</title>
                <link rel="canonical" href="https://southvanmed.com/register" />
                <meta name="description" content="South Vancouver medical clinic registration page, register now to get access to all services." />
                <meta name="keywords" content="South Vancouver medical clinic sign up, South Vancouver medical clinic register" />

            </Helmet>
            <CommonPageHeader title="Welcome to South Vancouver Medical Clinic" subtitle="Register" titleSmall={renderTitle()} />
            <RegisteArea />
        </>
    );
};

export default Register;